import { render, staticRenderFns } from "./SocialLoginValidation.vue?vue&type=template&id=0d8756ed&scoped=true&"
import script from "./SocialLoginValidation.vue?vue&type=script&lang=js&"
export * from "./SocialLoginValidation.vue?vue&type=script&lang=js&"
import style0 from "./SocialLoginValidation.vue?vue&type=style&index=0&id=0d8756ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8756ed",
  null
  
)

export default component.exports